import React from 'react'
import Input from '../../UI/Input/Input'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import {updateObject, checkValidity} from '../../../shared/utility'
import './ShiftForm.css'
import Fade from 'react-reveal/Fade'
import FetchData from '../../../shared/fetchData'

        const ShiftForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [id, setId] = React.useState('')
    const [shift, setShift] = React.useState({
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'ساعت شروع'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        },
        endTime: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'ساعت پایان'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        if (props.edit == true) {
            const lckrTp = shift
            lckrTp.startTime.value = props.shift.startTime
            lckrTp.endTime.value = props.shift.endTime
            setShift(lckrTp)
            setEdit(true)
            setId(props.shift.id)
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(shift, {
            [controlName]: updateObject(shift[controlName], {
                value: event.target.value
            })
        });
        setShift(updatedControls)
    }

    const shiftSubmit = (event) => {
        if (!edit) {
            setLoading(true)
            const lckrTp = shift
            var raw = JSON.stringify({
                "shift": {
                    "startTime": lckrTp.startTime.value,
                    "endTime": lckrTp.endTime.value
                },
                "version": "mtpx001"
            })

            var url = 'management/api/v1/shifts/insertShift'
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewLockerForm(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
        } else {
            setLoading(true)
            const lckrTp = shift
            console.log(lckrTp)
            var raw = JSON.stringify({
                "shift": {
                    "id": id,
                    "startTime": lckrTp.startTime.value,
                    "endTime": lckrTp.endTime.value
                },
                "version": "mtpx001"
            })

            var url = 'management/api/v1/shifts/updateShift'
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewLockerForm(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
        }
    }

    const formElementsArray = [];
    for (let key in shift) {
        formElementsArray.push({
            id: key,
            config: shift[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    search={true}
                    col="6 mt-2"
                    changed={(event) => inputChangedHandler(event, formElement.id)} />
                );
    })
    return (
            <Fade duration={200} left cascade>
                <div>
                    <div className='row justify-content-center'>
                        <div className='shift-cntnr'>
                            <ContentForm headetText='نوع باکس'>
                                <div className='shift-frm'>
                                    {form}
                                </div>
                                <div className='row justify-content-center w-100 mt-3'>
                                    <div className='col-6 text-center'>
                                        <Button btnType="General" clicked={(event) => props.toggleNewLockerForm(event, false)}>برگشت</Button>
                                    </div>
                                    <div className='col-6 text-center'>
                                        <Button btnType="Success" clicked={shiftSubmit}>ثبت</Button>
                                    </div>
                                </div>
                            </ContentForm>
                        </div>
                    </div>
                </div>
            </Fade>
            )
}

export default ShiftForm